import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../../layout/Dashboard/Dashboard";
import CookieSetting from "../../components/Cookies/CookiesSetting";
import "./SettingsPage.scss";
import AccountSettings from "../../components/Forms/UserSetting/AccountSettings";
import Preferences from "../../components/Forms/UserSetting/Preferences";
import PasswordSettings from "../../components/Forms/UserSetting/PasswordSettings";
import CookieManager from "../../components/Cookies/CookieManager";
import { useSetting } from "../../hooks/useSetting";
import { useTranslation } from "react-i18next";

const SettingsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { settingGet } = useSetting();

  const [activeTab, setActiveTab] = useState("account");
  const { t } = useTranslation();

  useEffect(() => {
    const fetchSettings = async () => {
      const settings = await settingGet();
      if (settings) {
        // Set the fetched settings in localStorage
        localStorage.setItem("theme", settings.theme);
        localStorage.setItem("language", settings.language);
        localStorage.setItem("fullName", settings.fullName);
        localStorage.setItem("gender", settings.gender);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location.search]);

  const handleTabClick = (tabName) => {
    navigate(`/settings?tab=${tabName}`);
    setActiveTab(tabName);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "account":
        return <AccountSettings />;
      case "preferences":
        return <Preferences />;
      case "password":
        return <PasswordSettings />;
      case "cookies":
        return <CookieSetting />;
      default:
        return null;
    }
  };

  return (
    <Dashboard>
      <CookieManager />

      <div className="settingsContainer">
        <div className="tabs">
          <button
            className={`tab ${activeTab === "account" ? "active" : ""}`}
            onClick={() => handleTabClick("account")}
          >
            {t("accountSettings")}
          </button>
          <button
            className={`tab ${activeTab === "preferences" ? "active" : ""}`}
            onClick={() => handleTabClick("preferences")}
          >
            {t("preferences")}
          </button>
          <button
            className={`tab ${activeTab === "password" ? "active" : ""}`}
            onClick={() => handleTabClick("password")}
          >
            {t("password")}
          </button>
          <button
            className={`tab ${activeTab === "cookies" ? "active" : ""}`}
            onClick={() => handleTabClick("cookies")}
          >
            {t("cookies")}
          </button>
        </div>
        <div className="tab-content">{renderContent()}</div>
      </div>
    </Dashboard>
  );
};

export default SettingsPage;
